module.exports = __webpack_public_path__ + "img/6-5.d141d47b.png";